window.mcb.forms.fields = window.mcb.forms.fields || {};
window.mcb.forms.fields.extensions = window.mcb.forms.fields.extensions || {};
window.mcb.forms.fields.extensions.choice = function (parent, shared) {
    const _thisField = parent;
    const _shared = shared;
    let _typedChoice = null;

    const controlTypes = {
        radio: 'RadioButtons',
        accordion: 'Accordion'
    };

    {
        if (_thisField.settings.data.control === controlTypes.radio) {
            _typedChoice = new window.mcb.forms.fields.extensions.choiceAsRadio(_thisField, _shared);
        }
        else if (_thisField.settings.data.control === controlTypes.accordion) {
            _typedChoice = new window.mcb.forms.fields.extensions.choiceAsAccordion(_thisField, _shared);
        }
        else {
            _typedChoice = new window.mcb.forms.fields.extensions.choiceAsSelect(_thisField, _shared);
        }
    }

    const render = function (fieldGroup) {
        return _typedChoice.render(fieldGroup);
    };

    const getValue = function (allowValueFormatting) {
        return _typedChoice.getValue(allowValueFormatting);
    };

    const setValue = function (value) {
        return _typedChoice.setValue(value);
    }

    const onRendered = function () {
        if (typeof _typedChoice.onRendered === "function") {
            return _typedChoice.onRendered();
        }

        return;
    };

    return _ = {
        render: render,
        onRendered: onRendered,
        getValue: getValue,
        setValue: setValue
    };
};
